import EquityDividendReport from "./components/reports/EquityDividendReport";
import { DefaultLayout } from "./layout/DefaultLayout";

// Route constants for better maintainability
export const ROUTES = {
  DEFAULT_LOGIN: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  DESIGNATION: '/designation',
  ROLE: '/role',
  LOOKUP: '/lookup',
  TEMPLATE: '/template',
  EVENT: '/event',
  TRIGGER_EVENT: '/trigger-event',
  EVENT_RULE: '/event-rule',
  SECTOR: '/sector',
  STOCK: '/stock',
  VENDOR: '/vendor',
  EXPENSE_HEAD: '/expense-head',
  WORKING_PARTNER_PAYOUT: '/working-partner-payout',
  TAX_MASTER: '/tax-master',
  ADVANCE_TAX_DATE: '/advance-tax-date',
  TRADE_DETAIL: '/trade-detail',
  CAPITAL_ADDITION: '/capital-addition',
  CAPITAL_CONTRIBUTION: '/capital-contribution',
  CLOSING_STOCK: '/closing-stock',
  PROFIT_ALLOCATION: '/profit-allocation',
  PARTNER_REMUNERATION: '/partner-remuneration',
  EXPENSES: '/expenses',
  NET_WORTH: '/net-worth',
  TARGETS: '/targets',
  TARGET_PURCHASE: '/target-purchase',
  PROFIT_RELEASE: '/profit-release',
  PAYMENT_RELEASE: '/payment-release',
  MUTUAL_FUNDS: '/mutual-funds',
  DIVIDEND: '/dividend',
  VENDOR_PAYOUT: '/vendor-payout',
  LOOKUP_MASTER: '/lookup-master',
  USER_MASTER: '/user-master',
  ROLE_RIGHTS: '/role-rights',
  OPENING_MONTH_STOCK: '/opening-month-stock',
  CLOSING_MONTH_STOCK: '/closing-month-stock',
  MOMS: '/moms',
  TRADE_REPORT: '/trade-report',
  EQUITY_DIVIDENT_REPORT: '/equity-dividend-report',
  MF_DIVIDEND_REPORT: '/mf-dividend-report', // ✨ ADD THIS
  NET_WORTH_REPORT: '/net-worth-report', 
  IN_FLOW_OUTFLOW_REPORT: '/inflow-outflow-report', // ✨ ADD THIS
  CAPITAL_CONTRIBUTION_REPORT: '/capital-contribution-report', // ✨ ADD THIS
  WORKING_PARTNER_PAYOUT_REPORT: '/working-partner-payout-report',
  EQUITY_PORTFOLIO_REPORT: '/equity-portfolio-report',
  MUTUAL_FUND_HOLDING_REPORT: '/mutual-fund-holding-report',
  MONTHLY_REPORT: '/monthly-report',
  REINVESTMENT_REPORT: '/reinvestment-report',
  PROFIT_SHARE_PERCENTAGE_REPORT: '/profit-share-report',
  PROFIT_LOSS_REPORT: '/pl-report',
  PORTFOLIO_SUMMARY_REPORT: '/portfolio-summary-report',
  PARTNER_DETAILS_REPORT: '/partner-details-report',
  PROFIT_RELEASE_REPORT: '/profit-release-report',
  TARGET_REPORT: '/target-report',
  NOMINEE_REPORT: '/nominee-report',
  ANNUAL_REPORT: '/annual-report',
  MOM_REPORT: '/mom-report',
  UPLOAD: '/upload-screen',
  USER_PROFILE: '/user-profile',
};